import ComponentRenderProxy from "vue"
import { SuusMention } from "components/Wysiwyg/extensions/suus-mention/SuusMention"
import { VueRenderer } from "@tiptap/vue-2"
import MentionList from "components/Wysiwyg/extensions/suus-mention/MentionList.vue"
import tippy from "tippy.js"

export type SuggestionFunction = ({
  query: string,
  editor: Editor,
}) => Mentionable[] | Promise<Mentionable[]>

interface Mentionable {
  id: number
  name: string
  key: string
  klass: "member-mention" | "group-mention"
}

export function ConfiguredSuusMentionExtension(
  suggestionFunction: SuggestionFunction,
  parentComponent: ComponentRenderProxy
) {
  return SuusMention.configure({
    suggestion: {
      decorationTag: "a",
      allowSpaces: true,
      items: suggestionFunction,

      render: () => {
        let component
        let popup

        return {
          onBeforeStart: (props) => {
            component = new VueRenderer(MentionList, {
              // using vue 2:
              parent: parentComponent,
              propsData: props,
              // using vue 3:
              // props,
              // editor: props.editor,
            })

            if (!props.clientRect) {
              return
            }

            popup = tippy("body", {
              getReferenceClientRect: props.clientRect,
              appendTo: () => document.body,
              content: component.element,
              showOnCreate: true,
              interactive: true,
              trigger: "manual",
              placement: "bottom-start",
            })
          },

          onUpdate(props) {
            component.updateProps(props)

            if (!props.clientRect) {
              return
            }

            popup[0].setProps({
              getReferenceClientRect: props.clientRect,
            })
          },

          onKeyDown(props) {
            if (props.event.key === "Escape") {
              popup[0].hide()

              return true
            }

            return component?.ref?.onKeyDown(props)
          },

          onExit() {
            popup[0].destroy()
            component.destroy()
          },
        }
      },
    },
  })
}
